import {GaEntityType} from '@optimaxdev/analytics/dist/types/types';
import {
    CATEGORY,
    createGAEvent,
    GENERAL,
    PDP,
    pushDataLayer,
    sendMobileAnalyticsEvent,
} from '@optimaxdev/analytics/mobile';
import {TryOnFaceType} from 'features/tryOn/reducers/collection';
import {GENDER_KEYS_LIST} from 'constants/gender';

export type LabelType = string | {[key: string]: string} | undefined | null;
export type OptionDataType = {
    isDefault?: boolean;
    isPopupTryOn?: boolean;
};

/**
 * Send analytics
 * @deprecated use sendMobileAnalyticsEvent instead
 * @param {GaEntityType} event - event for sending analytics
 * @param {LabelType} label - data value for send analytics
 * @param {boolean} isInteraction - is interation event
 */
export const sendAnalytics = (event: GaEntityType, label?: LabelType, isInteraction = true) => {
    const dataValue = {
        version: 'M',
    };

    const dataLabel =
        typeof label === 'string' || !label
            ? {
                  label: label || '',
              }
            : {
                  ...label,
              };

    Object.assign(dataValue, dataLabel);

    pushDataLayer(createGAEvent(event, dataValue, isInteraction));
};

/**
 * Sends analytics about browser messages
 * @param {string} message - text of the message
 * @returns {void}
 */
export const sendBrowserMessage = (message: string) =>
    sendMobileAnalyticsEvent(
        GENERAL.BROWSER_ERROR,
        {
            errorMsg: message,
        },
        false,
    );

/**
 * Sends alert message and triggers sending analytics callback with alert message
 * it is a temporary solution until we have notification component
 * @param {string} message - alert message
 */
export const showAlertAndSendAnalytics = (message = 'Something is wrong') => {
    alert(message);
    sendBrowserMessage(message);
};

/**
 * Add custom data.
 * @param {string} name - name for additional data.
 * @param {string | number} value - value for additional data.
 */
export const addCustomData = (name: string, value: string | number) => {
    if (__NODEJS__ || !window.LUX || !window.LUX.addData) return;
    window.LUX.addData(name, value);
};

/**
 * Send event to dataLayer
 * @param {PropsType} props - component props
 * @param {string} pageName - current page name
 * @param {OptionData} optionData - optional data
 */
export const sendEventToDataLayerForTryOn = (
    {gender, id, is_user_photo: isUserPhoto = false}: TryOnFaceType,
    pageName: string,
    {isDefault = false, isPopupTryOn}: OptionDataType,
) => {
    const genderValue = GENDER_KEYS_LIST[gender];
    const eventActionForCategory = CATEGORY[isPopupTryOn ? 'TRY_ON_POPUP' : 'TOP_MENU'];
    const eventNameForTryOn = {
        wishlist: GENERAL.WISHLIST_PRODUCT,
        category: eventActionForCategory,
        product: PDP.WISHLIST_USAGE,
    };
    const genderPart = genderValue
        ? ` - ${genderValue[0].toUpperCase() + genderValue.substring(1)}`
        : '';
    const modelPart = isUserPhoto || !gender ? 'You As Model' : id;
    const defaultPart = isDefault ? ' - Default' : '';

    if (eventNameForTryOn[pageName])
        sendMobileAnalyticsEvent(eventNameForTryOn[pageName], {
            actionDescribe: `TryOn Model${genderPart} - ${modelPart}${defaultPart}`,
            label: `TryOn Model${genderPart} - ${modelPart}${defaultPart}`,
        });
};
